<template>
  <b-navbar toggleable="lg" type="dark">
    <div class="container">
      <b-navbar-brand href="http://solostec.ch">
        <img src="logo.svg" width="30" height="30" class="d-inline-block align-top" alt="">
        {{brand}}
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/">{{ $t('home') }}</b-nav-item>
          <b-nav-item-dropdown :text="$t('products')" right>
            <b-dropdown-item to="/software">{{ $t('software') }}</b-dropdown-item>
            <b-dropdown-item to="/hosting">{{ $t('hosting') }}</b-dropdown-item>
            <b-dropdown-item to="/hardware">{{ $t('hardware') }}</b-dropdown-item>
            <b-dropdown-item to="/consulting">{{ $t('consulting') }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item to="/plog">{{ $t('blog') }}</b-nav-item>

          <!--<b-nav-item-dropdown :text="$t('admin')" right>
            <b-dropdown-item to="/plog">{{ $t('blog') }}</b-dropdown-item>
            <b-dropdown-item to="/admin">{{ $t('login') }}</b-dropdown-item>
          </b-nav-item-dropdown>-->

          <b-nav-item-dropdown :text="$t('contact')" right>
            <!-- <b-dropdown-item to="/support">{{ $t('support') }}</b-dropdown-item> -->
            <b-dropdown-item to="/team">{{ $t('team') }}</b-dropdown-item>
            <b-dropdown-item to="/downloads">{{ $t('downloads') }}</b-dropdown-item>
            <!-- <b-dropdown-item href="/cv">CV</b-dropdown-item> -->
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="$t('language')" right>
            <b-dropdown-item v-for="(name, code, idx) in avail" :key="idx" @click.stop="$i18n.locale = `${code}`">{{ name }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
  import { AVAILABLE_LANGUAGES } from '@/constants/languages'
  export default {
    name: 'navigation',
    data() {
      return {
        avail: AVAILABLE_LANGUAGES
      }
    },
    computed: {
      brand() {
        return this.$t('solostec')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
